import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

interface LinkToggleIconProps extends Omit<SvgIconProps, "viewBox"> {
}

export const LinkToggleIcon: FunctionComponent<LinkToggleIconProps> = (props) => {
	return (
		<SvgIcon
			viewBox="0 0 16 16"
			{...props}
		>
			<path d="M7.86953 10.2348L8.57664 10.9419L7.86953 10.2348ZM6.66921 11.4352L7.37632 12.1423L6.66921 11.4352ZM5.86899 12.2354L5.16189 11.5283L5.86899 12.2354ZM3.25011 9.61649L2.543 8.90938L3.25011 9.61649ZM5.25065 7.61596L4.54354 6.90885L5.25065 7.61596ZM7.76258 8.92757L7.16242 9.52773L8.57664 10.9419L9.1768 10.3418L7.76258 8.92757ZM7.16242 9.52773L5.9621 10.7281L7.37632 12.1423L8.57664 10.9419L7.16242 9.52773ZM5.9621 10.7281L5.16189 11.5283L6.5761 12.9425L7.37632 12.1423L5.9621 10.7281ZM5.16189 11.5283C4.52923 12.1609 3.87284 12.0259 3.66623 11.8193L2.25202 13.2335C3.49178 14.4732 5.44097 14.0776 6.5761 12.9425L5.16189 11.5283ZM3.66623 11.8193C3.45963 11.6126 3.32456 10.9563 3.95722 10.3236L2.543 8.90938C1.40788 10.0445 1.01225 11.9937 2.25202 13.2335L3.66623 11.8193ZM3.95722 10.3236L4.75743 9.52338L3.34322 8.10917L2.543 8.90938L3.95722 10.3236ZM4.75743 9.52338L5.95775 8.32306L4.54354 6.90885L3.34322 8.10917L4.75743 9.52338ZM5.95775 8.32306L6.55791 7.7229L5.1437 6.30869L4.54354 6.90885L5.95775 8.32306ZM7.75818 6.52249L8.35834 5.92233L6.94413 4.50812L6.34397 5.10828L7.75818 6.52249ZM8.35834 5.92233L9.55866 4.72201L8.14445 3.30779L6.94413 4.50812L8.35834 5.92233ZM9.55866 4.72201L10.3589 3.92179L8.94466 2.50758L8.14445 3.30779L9.55866 4.72201ZM10.3589 3.92179C10.9915 3.28914 11.6479 3.4242 11.8545 3.63081L13.2687 2.21659C12.029 0.976829 10.0798 1.37245 8.94466 2.50758L10.3589 3.92179ZM11.8545 3.63081C12.0611 3.83741 12.1962 4.49381 11.5635 5.12646L12.9778 6.54068C14.1129 5.40555 14.5085 3.45636 13.2687 2.21659L11.8545 3.63081ZM11.5635 5.12646L10.7633 5.92668L12.1775 7.34089L12.9778 6.54068L11.5635 5.12646ZM10.7633 5.92668L9.56301 7.127L10.9772 8.54121L12.1775 7.34089L10.7633 5.92668ZM9.56301 7.127L8.96285 7.72716L10.3771 9.14137L10.9772 8.54121L9.56301 7.127Z" fill="#79818F" />
			<rect
				height="3.08638"
				stroke="#79818F"
				strokeWidth="0.617277"
				transform="rotate(-45 2.39424 2.7998)"
				width="0.617277"
				x="2.39424"
				y="2.7998"
			/>
			<rect
				height="1.23455"
				stroke="#79818F"
				strokeWidth="0.617276"
				transform="rotate(-90 2.2664 6.34468)"
				width="0.617276"
				x="2.2664"
				y="6.34468"
			/>
			<rect
				height="1.23455"
				stroke="#79818F"
				strokeWidth="0.617276"
				transform="matrix(-1 0 0 1 6.06705 1.92773)"
				width="0.617276"
				x="-0.308638"
				y="0.308638"
			/>
			<path d="M10.9876 10.852L12.8993 12.7638L12.7335 12.9296L10.8217 11.0178L10.9876 10.852Z" stroke="#79818F" />
			<rect
				height="1.23455"
				stroke="#79818F"
				strokeWidth="0.617277"
				transform="rotate(90 13.2983 9.21879)"
				width="0.617277"
				x="13.2983"
				y="9.21879"
			/>
			<rect
				height="1.23455"
				stroke="#79818F"
				strokeWidth="0.617277"
				transform="matrix(1 0 0 -1 8.87939 13.0204)"
				width="0.617277"
				x="0.308638"
				y="-0.308638"
			/>
		</SvgIcon>
	);
};

export default LinkToggleIcon;